import React, { lazy, Suspense } from "react";
import { Text } from "react-native";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { logAnalyticsEvent } from "../../utils/firebase";
const LegendsViewCommon = lazy(() => import("./LegendsViewCommon"));

/**
 * LegendsView component renders the LegendsViewCommon component with FontAwesomeIcon as a prop.
 *
 * @component
 * @returns {JSX.Element} The rendered LegendsViewCommon component.
 */
const LegendsView = () => {
  logAnalyticsEvent("screen_view", { name: "Trails-LegendsView" });
  return (
    <Suspense fallback={<Text>Loading...</Text>}>
      <LegendsViewCommon FontAwesomeIcon={FontAwesomeIcon} />
    </Suspense>
  );
};

export default LegendsView;
